module.exports = __webpack_public_path__ + "static/media/remind-white-small.6dc7d4f3.svg";